import React from "react";

type Props = {
  className?: string;
  size?: number;
  color?: string;
};

const StarAlertIcon = ({ className = "", size = 62, color = "#1E40AF" }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M31 3.5C46.1878 3.5 58.5 15.8122 58.5 31C58.5 46.1878 46.1878 58.5 31 58.5C15.8122 58.5 3.5 46.1878 3.5 31C3.5 15.8122 15.8122 3.5 31 3.5Z"
        fill="#DBEAFE"
      />
      <path
        d="M31 3.5C46.1878 3.5 58.5 15.8122 58.5 31C58.5 46.1878 46.1878 58.5 31 58.5C15.8122 58.5 3.5 46.1878 3.5 31C3.5 15.8122 15.8122 3.5 31 3.5Z"
        stroke="#EFF6FF"
        strokeWidth="7"
      />
      <path
        d="M30.9993 20.1667L34.3468 26.9484L41.8327 28.0426L36.416 33.3184L37.6943 40.7717L30.9993 37.2509L24.3043 40.7717L25.5827 33.3184L20.166 28.0426L27.6518 26.9484L30.9993 20.1667Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StarAlertIcon;
